module.exports = __webpack_public_path__ + "static/img/gyl.daa2e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gyl.png
// module id = /9V7
// module chunks = 0